export default "__VITE_ASSET__qdN_CrI_i6cxNZNR4eAafA__";